/**
 * 請求先 事業者重複チェック
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/billing_address/restriction_confirms`

const billing_address_restriction_confirm = {
  namespaced: true,
  actions: {
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}

export default billing_address_restriction_confirm
